const PANEL = 'panel-';
const KEYS = {
    space: 32,
    enter: 13,
    left: 37,
    right: 39,
    home: 36,
    end: 35,
};

export { KEYS, PANEL };
